/* ═══════════════════════════════════════════════════════════════════════
   IBERIAN 3D STUDIO — main.js  v=20260609
   Lean build: no GSAP, no localStorage cart (Shopify AJAX handles that)
   IIFE pattern — no ES modules — works on any host
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  function safe(fn, name) {
    try { fn(); } catch (e) { console.warn("[I3D:" + name + "]", e); }
  }

  /* ─── SPLASH ─────────────────────────────────────────────────────────── */
  function initSplash() {
    var splash = document.querySelector("[data-splash]");
    if (!splash) return;
    function hide() { splash.classList.add("is-out"); }
    if (document.readyState === "complete") {
      setTimeout(hide, 500);
    } else {
      window.addEventListener("load", function () { setTimeout(hide, 400); });
    }
    setTimeout(hide, 3500); /* safety cap */
  }

  /* ─── NAV (scroll shadow) ────────────────────────────────────────────── */
  function initNav() {
    var nav = document.getElementById("nav");
    if (!nav) return;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        nav.classList.toggle("is-scrolled", window.scrollY > 60);
        ticking = false;
      });
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ─── SMOOTH ANCHOR SCROLL ──────────────────────────────────────────── */
  function initSmoothScroll() {
    document.addEventListener("click", function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute("href");
      if (!id || id === "#") return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      var offset = window.scrollY + target.getBoundingClientRect().top - 80;
      window.scrollTo({ top: offset, behavior: "smooth" });
    });
  }

  /* ─── CUSTOM CURSOR (instant — no lerp delay) ───────────────────────── */
  function initCursor() {
    if (matchMedia("(hover: none)").matches) return;
    var cursor = document.getElementById("cursor");
    if (!cursor) return;
    var dot  = cursor.querySelector(".cursor-dot");
    var ring = cursor.querySelector(".cursor-ring");
    if (!dot || !ring) return;

    var ready = false;
    window.addEventListener("mousemove", function (e) {
      var t = "translate3d(" + e.clientX + "px," + e.clientY + "px,0) translate(-50%,-50%)";
      dot.style.transform  = t;
      ring.style.transform = t;
      if (!ready) { ready = true; cursor.classList.add("is-ready"); }
    }, { passive: true });

    document.addEventListener("mouseover", function (e) {
      if (e.target.closest("a, button, .product-card, .btn-card")) {
        ring.classList.add("is-hover");
      }
    });
    document.addEventListener("mouseout", function (e) {
      if (e.target.closest("a, button, .product-card, .btn-card")) {
        ring.classList.remove("is-hover");
      }
    });
  }

  /* ─── REVEAL on scroll (IntersectionObserver) ──────────────────────── */
  function initReveals() {
    var els = document.querySelectorAll(".reveal");
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseFloat(el.dataset.revealIdx || 0) * 0.08;
        el.style.transitionDelay = delay + "s";
        el.classList.add("is-visible");
        io.unobserve(el);
      });
    }, { threshold: 0.05, rootMargin: "0px 0px -4% 0px" });

    var parents = new Map();
    els.forEach(function (el) {
      var parent = el.parentElement;
      var idx = parents.get(parent) || 0;
      el.dataset.revealIdx = idx;
      parents.set(parent, idx + 1);
      io.observe(el);
    });

    /* Safety: reveal anything still hidden after 5s */
    setTimeout(function () {
      document.querySelectorAll(".reveal:not(.is-visible)").forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 1.1) {
          el.classList.add("is-visible");
        }
      });
    }, 5000);
  }

  /* ─── COUNT-UP NUMBERS ──────────────────────────────────────────────── */
  function initCountUp() {
    var els = document.querySelectorAll("[data-count-to],[data-count-float]");
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var isFloat = el.hasAttribute("data-count-float");
        var target  = parseFloat(el.getAttribute("data-count-to") || el.getAttribute("data-count-float"));
        var start   = null;
        var duration = 1200;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / duration, 1);
          var ease = 1 - Math.pow(1 - p, 3);
          el.textContent = isFloat
            ? (target * ease).toFixed(1).replace(".", ",")
            : Math.round(target * ease).toLocaleString("es-ES");
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ─── PRODUCT CARD TILT (desktop only) ─────────────────────────────── */
  function initTilt() {
    if (matchMedia("(hover: none)").matches) return;
    document.querySelectorAll(".product-card").forEach(function (card) {
      card.addEventListener("mousemove", function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width  - 0.5;
        var y = (e.clientY - r.top)  / r.height - 0.5;
        card.style.transform =
          "perspective(700px) rotateY(" + (x * 10).toFixed(1) + "deg)" +
          " rotateX(" + (-y * 7).toFixed(1) + "deg) translateZ(6px)";
      });
      card.addEventListener("mouseleave", function () {
        card.style.transition = "transform 0.45s cubic-bezier(0.22,1,0.36,1)";
        card.style.transform  = "";
        setTimeout(function () { card.style.transition = ""; }, 450);
      });
    });
  }

  /* ─── BOOT ───────────────────────────────────────────────────────────── */
  function boot() {
    safe(initSplash,       "splash");
    safe(initNav,          "nav");
    safe(initSmoothScroll, "scroll");
    safe(initCursor,       "cursor");
    safe(initReveals,      "reveals");
    safe(initCountUp,      "countup");
    safe(initTilt,         "tilt");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

})();
